// // import React, { useState, useEffect, useMemo } from 'react';
// // import {
// //   Card,
// //   Row,
// //   CardTitle,
// //   CardBody,
// //   Button,
// //   FormGroup,
// //   Label,
// //   Input,
// //   FormText,
// // } from 'reactstrap';
// // import { useNavigate, useLocation } from 'react-router-dom';
// // import { apiService } from '../../constants/ApiService';
// // import { toast } from 'react-toastify';
// // import VendorBranchSelector from '../../components/VendorBranchSelector';
// // import { useSelector } from 'react-redux';
// // import useVendorBranch from '../../utils/useVendorBranch';
// // import conditionalDataLoad from '../../utils/conditionalDataLoad';

// // const initialFacultyData = {
// //   id: 0,
// //   vendor_id: 0,
// //   branch_id: 0,
// //   faculty_name: '',
// //   mobile: '',
// //   email: '',
// //   address: '',
// //   qualification: '',
// //   experience_years: '',
// //   arrival_time: '',
// //   departure_time: '',
// //   faculty_code: '',
// //   main_subject_taught: 0,
// //   is_working: 'true',
// //   branch_name: '',
// // };

// // const pick = (...vals) =>
// //   vals.find((v) => v !== undefined && v !== null && v !== '');

// // const normalizeBoolStr = (v) => {
// //   if (v === true || v === 'true' || v === 1 || v === '1') return 'true';
// //   if (v === false || v === 'false' || v === 0 || v === '0') return 'false';
// //   return 'true';
// // };

// // const AddFacultyMaster = () => {
// //   const navigate = useNavigate();
// //   const location = useLocation();

// //   const { user } = useSelector((state) => state.authState);
// //   const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
// //     useVendorBranch(user);

// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [loading, setLoading] = useState(false);

// //   const [branchMaster, setBranchMaster] = useState([]);
// //   const [venderMaster, setVenderMaster] = useState([]);

// //   const [subjectOptions, setSubjectOptions] = useState([]);
// //   const [facultyData, setFacultyData] = useState(initialFacultyData);

// //   const [errorMessage, setErrorMessage] = useState({});

// //   // =========================
// //   // ✅ EDIT LOAD (RESET + MAP)
// //   // =========================
// //   useEffect(() => {
// //     if (location.state) {
// //       const s = location.state;

// //       setFacultyData({
// //         ...initialFacultyData,

// //         id: Number(pick(s.id, s.faculty_id, s.faculty_id, 0)),
// //         vendor_id: Number(pick(s.vendor_id, s.vendorId, 0)),
// //         branch_id: Number(pick(s.branch_id, s.branchId, 0)),

// //         faculty_name: pick(s.faculty_name, s.faculty_name, ''),
// //         mobile: pick(s.mobile, ''),
// //         email: pick(s.email, ''),
// //         address: pick(s.address, ''),
// //         qualification: pick(s.qualification, ''),
// //         experience_years: pick(s.experience_years, s.experienceYears, ''),
// //         arrival_time: pick(s.arrival_time, s.arrivalTime, ''),
// //         departure_time: pick(s.departure_time, s.departureTime, ''),

// //         // ✅ IMPORTANT: faculty_code mapping
// //         faculty_code: pick(s.faculty_code, s.facultyCode, ''),

// //         // ✅ IMPORTANT: subject mapping
// //         main_subject_taught: Number(
// //           pick(
// //             s.main_subject_taught,
// //             s.main_subject_id,
// //             s.mainSubjectTaught,
// //             0,
// //           ),
// //         ),

// //         // ✅ bool -> "true"/"false"
// //         is_working: normalizeBoolStr(pick(s.is_working, s.status, 'true')),

// //         branch_name: pick(s.branch_name, s.branchName, ''),
// //       });
// //     } else {
// //       setFacultyData(initialFacultyData);
// //     }
// //   }, [location.state]);

// //   const onHandleBack = () => navigate('/faculty-list');

// //   const onChangeHandle = (e) => {
// //     const { name, value } = e.target;
// //     setFacultyData((prev) => ({ ...prev, [name]: value }));
// //     setErrorMessage((prev) => ({ ...prev, [name]: '' }));
// //   };

// //   // -------------------------
// //   // ✅ Load Subjects
// //   // -------------------------
// //   const loadSubjectOptions = async (vendorId, branchId) => {
// //     try {
// //       if (!vendorId && !branchId) {
// //         setSubjectOptions([]);
// //         return;
// //       }

// //       const params = new URLSearchParams();
// //       if (vendorId) params.append('vendorId', vendorId);
// //       if (branchId) params.append('branchId', branchId);
// //       params.append('search', '');

// //       const url = `api/SubjectMaster/GetSubjectMaster?${params.toString()}`;
// //       const res = await apiService.get(url);
// //       const container = res?.data ?? res;

// //       const list =
// //         (Array.isArray(container.data) && container.data) ||
// //         (Array.isArray(container.Data) && container.Data) ||
// //         (Array.isArray(container.list) && container.list) ||
// //         (Array.isArray(container.result) && container.result) ||
// //         (Array.isArray(container) && container) ||
// //         [];

// //       setSubjectOptions(list);
// //     } catch (err) {
// //       console.error(err);
// //       toast.error('Error loading subject list');
// //       setSubjectOptions([]);
// //     }
// //   };

// //   // ---------------------------------------------------
// //   //     LOAD SUBJECT OPTIONS WHEN VENDOR/BRANCH CHANGE
// //   // ---------------------------------------------------
// //   useEffect(() => {
// //     const canLoad = conditionalDataLoad({
// //       hasMultiBranch,
// //       hasSingleBranch,
// //       isSuperAdmin,
// //       isAdmin,
// //       vendorId: facultyData.vendor_id,
// //       branchId: facultyData.branch_id,
// //     });

// //     if (canLoad) {
// //       loadSubjectOptions(facultyData.vendor_id, facultyData.branch_id);
// //     }
// //   }, [
// //     facultyData.vendor_id,
// //     facultyData.branch_id,
// //     hasMultiBranch,
// //     hasSingleBranch,
// //     isSuperAdmin,
// //     isAdmin,
// //   ]);

// //   // -------------------------
// //   // ✅ Fetch Vendors
// //   // -------------------------
// //   const fetchVendors = async () => {
// //     try {
// //       const res = await apiService.get(`api/VendorMaster/GetAllVendor`);
// //       if (res?.status === true) setVenderMaster(res?.data || []);
// //       else setVenderMaster([]);
// //     } catch (e) {
// //       console.log(e);
// //       setVenderMaster([]);
// //     }
// //   };

// //   // -------------------------
// //   // ✅ Fetch Branches
// //   // -------------------------
// //   const fetchBranches = async (vendorId) => {
// //     try {
// //       if (!vendorId || Number(vendorId) <= 0) {
// //         setBranchMaster([]);
// //         return [];
// //       }

// //       const url = `/api/BranchMaster/all?pageNo=1&limit=100000&searchKey=&venderMasterId=${vendorId}`;
// //       const res = await apiService.get(url);

// //       if (res?.status === true) {
// //         const arr = Array.isArray(res?.branchMasterData)
// //           ? res.branchMasterData
// //           : [];

// //         const normalized = arr.map((x) => ({
// //           ...x,
// //           __id: Number(x?.id || 0),
// //           __name: String(x?.branch_name || '').trim(),
// //         }));

// //         setBranchMaster(normalized);
// //         return normalized;
// //       }

// //       setBranchMaster([]);
// //       return [];
// //     } catch (e) {
// //       console.log(e);
// //       setBranchMaster([]);
// //       return [];
// //     }
// //   };

// //   useEffect(() => {
// //     fetchVendors();
// //   }, []);

// //   useEffect(() => {
// //     if (facultyData.vendor_id) {
// //       fetchBranches(facultyData.vendor_id);
// //     }
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [facultyData.vendor_id]);

// //   const buildBranchIdAndNames = async (vendorId, branchId) => {
// //     const vid = Number(vendorId || 0);
// //     const bid = Number(branchId || 0);
// //     if (vid <= 0 || bid <= 0) return '';

// //     let list = branchMaster;
// //     if (!list || list.length === 0) {
// //       list = await fetchBranches(vid);
// //     }

// //     const row = (list || []).find((b) => Number(b.__id) === bid);
// //     const name = row?.__name ? String(row.__name).trim() : '';

// //     return name ? `${bid}-${name}` : String(bid);
// //   };

// //   // -------------------------
// //   // ✅ Validation
// //   // -------------------------
// //   const validateInputs = () => {
// //     const errors = {};

// //     if (
// //       isSuperAdmin &&
// //       (!facultyData.vendor_id || Number(facultyData.vendor_id) <= 0)
// //     ) {
// //       errors.vendor_id = 'Vendor is Required';
// //       toast.error('Please select a Vendor');
// //     }

// //     if (
// //       (isSuperAdmin || isAdmin || hasMultiBranch) &&
// //       (!facultyData.branch_id || Number(facultyData.branch_id) <= 0)
// //     ) {
// //       errors.branch_id = 'Branch is Required';
// //       toast.error('Please select a Branch');
// //     }

// //     if (!facultyData.faculty_name?.trim())
// //       errors.faculty_name = 'Faculty Name Required';

// //     if (!facultyData.mobile?.trim()) {
// //       errors.mobile = 'Mobile number is required';
// //     } else if (!/^[6-9]\d{9}$/.test(facultyData.mobile.trim())) {
// //       errors.mobile = 'Enter a valid 10-digit mobile number';
// //     }

// //     if (!facultyData.email?.trim()) {
// //       errors.email = 'Email is required';
// //     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(facultyData.email.trim())) {
// //       errors.email = 'Enter a valid email address';
// //     }

// //     setErrorMessage(errors);
// //     return Object.keys(errors).length === 0;
// //   };

// //   // -------------------------
// //   // ✅ Save Faculty
// //   // -------------------------
// //   const AddFaculty = async () => {
// //     const ok = validateInputs();
// //     if (!ok) return;

// //     try {
// //       let response;
// //       if (facultyData.id && Number(facultyData.id) !== 0) {
// //         response = await apiService.put(
// //           `api/FacultyMaster/UpdateFaculty?id=${facultyData.id}`,
// //           facultyData,
// //         );
// //       } else {
// //         response = await apiService.post(
// //           `api/FacultyMaster/AddFaculty`,
// //           facultyData,
// //         );
// //       }

// //       if (response?.status === true) {
// //         toast(response.message);
// //         navigate('/faculty-list');
// //       } else {
// //         toast(response?.message || 'Failed');
// //       }
// //     } catch (e) {
// //       console.log(e);
// //       toast.error('SomeThing went wrong!!');
// //     }
// //   };

// //   // -------------------------
// //   // ✅ Create Credentials
// //   // -------------------------
// //   const handleSubmit = async () => {
// //     if (isSubmitting) return;

// //     const ok = validateInputs();
// //     if (!ok) return;

// //     setIsSubmitting(true);
// //     setLoading(true);

// //     try {
// //       const vendorId = Number(facultyData.vendor_id || 0);
// //       const branchId = Number(facultyData.branch_id || 0);

// //       const branchIdAndNames = await buildBranchIdAndNames(vendorId, branchId);

// //       const params = {
// //         vender_master_id: vendorId,
// //         branch_id: branchId,
// //         branch_id_and_names: branchIdAndNames,
// //         sponsored_user_mobile: facultyData.mobile,
// //         user_name: facultyData.faculty_name,
// //         user_mobile: facultyData.mobile,
// //         user_pass: facultyData.mobile,
// //         confirm_user_pass: facultyData.mobile,
// //         user_email: facultyData.email || '',
// //         user_profile_id: 9,
// //         working_bussinesss_mode: 'SCHOOL',
// //         user_status: 'ACTIVE',
// //       };

// //       const response = await apiService.post(
// //         `api/admin/User_Detail/branch/CreateUser`,
// //         params,
// //       );

// //       if (response?.status === true)
// //         toast.success(response.message || 'User created');
// //       else toast.error(response?.message || 'Failed');
// //     } catch (err) {
// //       console.log(err);
// //       toast.error('SomeThing went wrong!!');
// //     } finally {
// //       setLoading(false);
// //       setIsSubmitting(false);
// //     }
// //   };

// //   return (
// //     <>
// //       <VendorBranchSelector
// //         user={user}
// //         selectionData={facultyData}
// //         setSelectionData={setFacultyData}
// //         errorMessage={errorMessage}
// //         accessButton={true}
// //       />

// //       <Card className='card-box height-100-p pd-20 mb-20'>
// //         <CardTitle
// //           tag='h6'
// //           className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
// //         >
// //           <div className='d-flex align-items-center'>
// //             <i className='bi bi-person-video3 mr-2'></i>
// //             Faculty Master Form
// //           </div>

// //           <div>
// //             <Button color='warning' onClick={onHandleBack} className='mr-2'>
// //               Back
// //             </Button>
// //           </div>
// //         </CardTitle>

// //         <CardBody>
// //           <Row>
// //             <FormGroup className='col-sm-6'>
// //               <Label>Faculty Name</Label>
// //               <Input
// //                 name='faculty_name'
// //                 value={facultyData.faculty_name}
// //                 onChange={onChangeHandle}
// //                 required
// //               />
// //               {errorMessage.faculty_name && (
// //                 <FormText color='danger'>{errorMessage.faculty_name}</FormText>
// //               )}
// //             </FormGroup>

// //             <FormGroup className='col-sm-6'>
// //               <Label>Faculty Code</Label>
// //               <Input
// //                 name='faculty_code'
// //                 value={facultyData.faculty_code}
// //                 onChange={onChangeHandle}
// //               />
// //             </FormGroup>

// //             <FormGroup className='col-sm-6'>
// //               <Label>Mobile No</Label>
// //               <Input
// //                 name='mobile'
// //                 value={facultyData.mobile}
// //                 onChange={onChangeHandle}
// //                 required
// //               />
// //               {errorMessage.mobile && (
// //                 <FormText color='danger'>{errorMessage.mobile}</FormText>
// //               )}
// //             </FormGroup>

// //             <FormGroup className='col-sm-6'>
// //               <Label>Email</Label>
// //               <Input
// //                 name='email'
// //                 value={facultyData.email}
// //                 onChange={onChangeHandle}
// //                 required
// //               />
// //               {errorMessage.email && (
// //                 <FormText color='danger'>{errorMessage.email}</FormText>
// //               )}
// //             </FormGroup>

// //             <FormGroup className='col-sm-6'>
// //               <Label>Qualification</Label>
// //               <Input
// //                 type='select'
// //                 className='custom-select'
// //                 name='qualification'
// //                 value={facultyData.qualification}
// //                 onChange={onChangeHandle}
// //               >
// //                 <option value=''>Select Qualification</option>
// //                 <option value='Graduate'>Graduate</option>
// //                 <option value='Post Graduate'>Post Graduate</option>
// //                 <option value='PhD'>PhD</option>
// //                 <option value='Diploma'>Diploma</option>
// //                 <option value='Other'>Other</option>
// //               </Input>
// //             </FormGroup>

// //             <FormGroup className='col-sm-6'>
// //               <Label>Experience</Label>
// //               <Input
// //                 type='select'
// //                 className='custom-select'
// //                 name='experience_years'
// //                 value={facultyData.experience_years}
// //                 onChange={onChangeHandle}
// //               >
// //                 <option value=''>Select Experience</option>
// //                 <option value='Fresher'>Fresher</option>
// //                 <option value='1+'>1+ Year</option>
// //                 <option value='5+'>5+ Years</option>
// //                 <option value='10+'>10+ Years</option>
// //                 <option value='15+'>15+ Years</option>
// //                 <option value='20+'>20+ Years</option>
// //               </Input>
// //             </FormGroup>

// //             <FormGroup className='col-sm-6'>
// //               <Label>Arrival Time</Label>
// //               <Input
// //                 type='time'
// //                 name='arrival_time'
// //                 value={facultyData.arrival_time}
// //                 onChange={onChangeHandle}
// //               />
// //             </FormGroup>

// //             <FormGroup className='col-sm-6'>
// //               <Label>Departure Time</Label>
// //               <Input
// //                 type='time'
// //                 name='departure_time'
// //                 value={facultyData.departure_time}
// //                 onChange={onChangeHandle}
// //               />
// //             </FormGroup>

// //             <FormGroup className='col-sm-6'>
// //               <Label>Main Subject Taught</Label>
// //               <Input
// //                 type='select'
// //                 className='custom-select'
// //                 name='main_subject_taught'
// //                 value={facultyData.main_subject_taught}
// //                 onChange={onChangeHandle}
// //               >
// //                 <option value=''>Select Subject</option>
// //                 {subjectOptions.map((sub, key) => (
// //                   <option key={key} value={sub.id}>
// //                     {sub.subject_name}
// //                   </option>
// //                 ))}
// //               </Input>
// //             </FormGroup>

// //             <FormGroup className='col-sm-6'>
// //               <Label>Status</Label>
// //               <Input
// //                 type='select'
// //                 className='custom-select'
// //                 name='is_working'
// //                 value={facultyData.is_working}
// //                 onChange={onChangeHandle}
// //               >
// //                 <option value='true'>Currently Working</option>
// //                 <option value='false'>Not Working</option>
// //               </Input>
// //             </FormGroup>

// //             <FormGroup className='col-sm-12'>
// //               <Label>Address</Label>
// //               <Input
// //                 name='address'
// //                 value={facultyData.address}
// //                 onChange={onChangeHandle}
// //               />
// //             </FormGroup>
// //           </Row>

// //           <div className='text-right'>
// //             {Number(facultyData.id) > 0 && (
// //               <Button
// //                 className='mt-2 mr-2 float-end'
// //                 color='primary'
// //                 onClick={handleSubmit}
// //                 disabled={loading || isSubmitting}
// //               >
// //                 <i className='bi bi-key' />{' '}
// //                 {loading ? 'Creating...' : 'Create Faculty Credentials'}
// //               </Button>
// //             )}

// //             <Button
// //               className='mt-2 float-end ms-2'
// //               color='success'
// //               onClick={AddFaculty}
// //               disabled={loading || isSubmitting}
// //             >
// //               <i className='bi bi-check-circle' /> Save Faculty Details
// //             </Button>
// //           </div>
// //         </CardBody>
// //       </Card>
// //     </>
// //   );
// // };

// // export default AddFacultyMaster;
// //new
// import React, { useState, useEffect } from 'react';
// import {
//   Card,
//   Row,
//   CardTitle,
//   CardBody,
//   Button,
//   FormGroup,
//   Label,
//   Input,
//   FormText,
// } from 'reactstrap';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import { toast } from 'react-toastify';
// import VendorBranchSelector from '../../components/VendorBranchSelector';
// import { useSelector } from 'react-redux';
// import useVendorBranch from '../../utils/useVendorBranch';
// import conditionalDataLoad from '../../utils/conditionalDataLoad';

// const initialFacultyData = {
//   id: 0,
//   faculty_id: 0,
//   vendor_id: 0,
//   branch_id: 0,
//   faculty_name: '',
//   mobile: '',
//   email: '',
//   address: '',
//   qualification: '',
//   experience_years: '',
//   arrival_time: '',
//   departure_time: '',
//   faculty_code: '',
//   main_subject_taught: 0,
//   is_working: 'true',
//   branch_name: '',
//   salary_amount: 0,
// };

// const pick = (...vals) =>
//   vals.find((v) => v !== undefined && v !== null && v !== '');

// const normalizeBoolStr = (v) => {
//   if (v === true || v === 'true' || v === 1 || v === '1') return 'true';
//   if (v === false || v === 'false' || v === 0 || v === '0') return 'false';
//   return 'true';
// };

// const AddFacultyMaster = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const { user } = useSelector((state) => state.authState || {});
//   const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
//     useVendorBranch(user);

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const [branchMaster, setBranchMaster] = useState([]);
//   const [venderMaster, setVenderMaster] = useState([]);
//   const [subjectOptions, setSubjectOptions] = useState([]);
//   const [facultyData, setFacultyData] = useState(initialFacultyData);
//   const [errorMessage, setErrorMessage] = useState({});

//   useEffect(() => {
//     if (location.state) {
//       const s = location.state;

//       setFacultyData({
//         ...initialFacultyData,

//         id: Number(pick(s.id, s.faculty_id, 0)),
//         faculty_id: Number(pick(s.faculty_id, s.id, 0)),
//         vendor_id: Number(pick(s.vendor_id, s.vendorId, 0)),
//         branch_id: Number(pick(s.branch_id, s.branchId, 0)),

//         faculty_name: pick(s.faculty_name, ''),
//         mobile: pick(s.mobile, ''),
//         email: pick(s.email, ''),
//         address: pick(s.address, ''),
//         qualification: pick(s.qualification, ''),
//         experience_years: pick(s.experience_years, s.experienceYears, ''),
//         arrival_time: pick(s.arrival_time, s.arrivalTime, ''),
//         departure_time: pick(s.departure_time, s.departureTime, ''),
//         faculty_code: pick(s.faculty_code, s.facultyCode, ''),
//         salary_amount: Number(pick(s.salary_amount, s.salaryAmount, 0)),
//         main_subject_taught: Number(
//           pick(
//             s.main_subject_taught,
//             s.main_subject_id,
//             s.mainSubjectTaught,
//             0,
//           ),
//         ),
//         is_working: normalizeBoolStr(pick(s.is_working, s.status, 'true')),
//         branch_name: pick(s.branch_name, s.branchName, ''),
//       });
//     } else {
//       setFacultyData(initialFacultyData);
//     }
//   }, [location.state]);

//   const onHandleBack = () => navigate('/faculty-list');

//   // const onChangeHandle = (e) => {
//   //   const { name, value } = e.target;
//   //   setFacultyData((prev) => ({ ...prev, [name]: value }));
//   //   setErrorMessage((prev) => ({ ...prev, [name]: '' }));
//   // };
// const onChangeHandle = (e) => {
//   const { name, value } = e.target;

//   setFacultyData((prev) => ({
//     ...prev,
//     [name]:
//       name === 'salary_amount'
//         ? value === ''
//           ? ''
//           : Number(value)
//         : value,
//   }));

//   setErrorMessage((prev) => ({ ...prev, [name]: '' }));
// };
//   const loadSubjectOptions = async (vendorId, branchId) => {
//     try {
//       if (!vendorId && !branchId) {
//         setSubjectOptions([]);
//         return;
//       }

//       const params = new URLSearchParams();
//       if (vendorId) params.append('vendorId', vendorId);
//       if (branchId) params.append('branchId', branchId);
//       params.append('search', '');

//       const url = `api/SubjectMaster/GetSubjectMaster?${params.toString()}`;
//       const res = await apiService.get(url);
//       const container = res?.data ?? res;

//       const list =
//         (Array.isArray(container.data) && container.data) ||
//         (Array.isArray(container.Data) && container.Data) ||
//         (Array.isArray(container.list) && container.list) ||
//         (Array.isArray(container.result) && container.result) ||
//         (Array.isArray(container) && container) ||
//         [];

//       setSubjectOptions(list);
//     } catch (err) {
//       console.error(err);
//       toast.error('Error loading subject list');
//       setSubjectOptions([]);
//     }
//   };

//   useEffect(() => {
//     const canLoad = conditionalDataLoad({
//       hasMultiBranch,
//       hasSingleBranch,
//       isSuperAdmin,
//       isAdmin,
//       vendorId: facultyData.vendor_id,
//       branchId: facultyData.branch_id,
//     });

//     if (canLoad) {
//       loadSubjectOptions(facultyData.vendor_id, facultyData.branch_id);
//     }
//   }, [
//     facultyData.vendor_id,
//     facultyData.branch_id,
//     hasMultiBranch,
//     hasSingleBranch,
//     isSuperAdmin,
//     isAdmin,
//   ]);

//   const fetchVendors = async () => {
//     try {
//       const res = await apiService.get(`api/VendorMaster/GetAllVendor`);
//       if (res?.status === true) setVenderMaster(res?.data || []);
//       else setVenderMaster([]);
//     } catch (e) {
//       console.log(e);
//       setVenderMaster([]);
//     }
//   };

//   const fetchBranches = async (vendorId) => {
//     try {
//       if (!vendorId || Number(vendorId) <= 0) {
//         setBranchMaster([]);
//         return [];
//       }

//       const url = `/api/BranchMaster/all?pageNo=1&limit=100000&searchKey=&venderMasterId=${vendorId}`;
//       const res = await apiService.get(url);

//       if (res?.status === true) {
//         const arr = Array.isArray(res?.branchMasterData)
//           ? res.branchMasterData
//           : [];

//         const normalized = arr.map((x) => ({
//           ...x,
//           __id: Number(x?.id || 0),
//           __name: String(x?.branch_name || '').trim(),
//         }));

//         setBranchMaster(normalized);
//         return normalized;
//       }

//       setBranchMaster([]);
//       return [];
//     } catch (e) {
//       console.log(e);
//       setBranchMaster([]);
//       return [];
//     }
//   };

//   useEffect(() => {
//     fetchVendors();
//   }, []);

//   useEffect(() => {
//     if (facultyData.vendor_id) {
//       fetchBranches(facultyData.vendor_id);
//     }
//   }, [facultyData.vendor_id]);

//   const buildBranchIdAndNames = async (vendorId, branchId) => {
//     const vid = Number(vendorId || 0);
//     const bid = Number(branchId || 0);
//     if (vid <= 0 || bid <= 0) return '';

//     let list = branchMaster;
//     if (!list || list.length === 0) {
//       list = await fetchBranches(vid);
//     }

//     const row = (list || []).find((b) => Number(b.__id) === bid);
//     const name = row?.__name ? String(row.__name).trim() : '';

//     return name ? `${bid}-${name}` : String(bid);
//   };

//   const validateInputs = () => {
//     const errors = {};

//     if (
//       isSuperAdmin &&
//       (!facultyData.vendor_id || Number(facultyData.vendor_id) <= 0)
//     ) {
//       errors.vendor_id = 'Vendor is Required';
//       toast.error('Please select a Vendor');
//     }

//     if (
//       (isSuperAdmin || isAdmin || hasMultiBranch) &&
//       (!facultyData.branch_id || Number(facultyData.branch_id) <= 0)
//     ) {
//       errors.branch_id = 'Branch is Required';
//       toast.error('Please select a Branch');
//     }

//     if (!facultyData.faculty_name?.trim()) {
//       errors.faculty_name = 'Faculty Name Required';
//     }

//     if (!facultyData.mobile?.trim()) {
//       errors.mobile = 'Mobile number is required';
//     } else if (!/^[6-9]\d{9}$/.test(facultyData.mobile.trim())) {
//       errors.mobile = 'Enter a valid 10-digit mobile number';
//     }

//     if (!facultyData.email?.trim()) {
//       errors.email = 'Email is required';
//     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(facultyData.email.trim())) {
//       errors.email = 'Enter a valid email address';
//     }

//     setErrorMessage(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const AddFaculty = async () => {
//     const ok = validateInputs();
//     if (!ok) return;

//     try {
//       let response;
//       if (facultyData.faculty_id && Number(facultyData.faculty_id) !== 0) {
//         response = await apiService.put(
//           `api/FacultyMaster/UpdateFaculty?id=${facultyData.faculty_id}`,
//           facultyData,
//         );
//       } else {
//         response = await apiService.post(
//           `api/FacultyMaster/AddFaculty`,
//           facultyData,
//         );
//       }

//       if (response?.status === true) {
//         toast(response.message || 'Saved successfully');
//         navigate('/faculty-list');
//       } else {
//         toast(response?.message || 'Failed');
//       }
//     } catch (e) {
//       console.log(e);
//       toast.error('SomeThing went wrong!!');
//     }
//   };

//   const handleSubmit = async () => {
//     if (isSubmitting) return;

//     const ok = validateInputs();
//     if (!ok) return;

//     const selectedFacultyId = Number(
//       facultyData.faculty_id || facultyData.id || 0,
//     );

//     if (!selectedFacultyId || selectedFacultyId <= 0) {
//       toast.error('Please save faculty details first');
//       return;
//     }

//     setIsSubmitting(true);
//     setLoading(true);

//     try {
//       const vendorId = Number(facultyData.vendor_id || 0);
//       const branchId = Number(facultyData.branch_id || 0);
//       const branchIdAndNames = await buildBranchIdAndNames(vendorId, branchId);

//       const params = {
//         vender_master_id: vendorId,
//         branch_id: branchId,
//         branch_id_and_names: branchIdAndNames,
//         sponsored_user_mobile: facultyData.mobile,
//         user_name: facultyData.faculty_name,
//         user_mobile: facultyData.mobile,
//         user_pass: facultyData.mobile,
//         confirm_user_pass: facultyData.mobile,
//         user_email: facultyData.email || '',
//         user_profile_id: 9,
//         working_bussinesss_mode: 'SCHOOL',
//         user_status: 'ACTIVE',

//         tbl_link_id: selectedFacultyId,
//         tbl_linked_with: 'FACULTY_MASTER',
//       };

//       const response = await apiService.post(
//         `api/admin/User_Detail/branch/CreateUser`,
//         params,
//       );

//       if (response?.status === true) {
//         toast.success(response.message || 'User created');
//       } else {
//         toast.error(response?.message || 'Failed');
//       }
//     } catch (err) {
//       console.log(err);
//       toast.error('SomeThing went wrong!!');
//     } finally {
//       setLoading(false);
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <>
//       <VendorBranchSelector
//         user={user}
//         selectionData={facultyData}
//         setSelectionData={setFacultyData}
//         errorMessage={errorMessage}
//         accessButton={true}
//       />

//       <Card className='card-box height-100-p pd-20 mb-20'>
//         <CardTitle
//           tag='h6'
//           className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
//         >
//           <div className='d-flex align-items-center'>
//             <i className='bi bi-person-video3 mr-2'></i>
//             Faculty Master Form
//           </div>

//           <div>
//             <Button color='warning' onClick={onHandleBack} className='mr-2'>
//               Back
//             </Button>
//           </div>
//         </CardTitle>

//         <CardBody>
//           <Row>
//             <FormGroup className='col-sm-6'>
//               <Label>Faculty Name</Label>
//               <Input
//                 name='faculty_name'
//                 value={facultyData.faculty_name}
//                 onChange={onChangeHandle}
//                 required
//               />
//               {errorMessage.faculty_name && (
//                 <FormText color='danger'>{errorMessage.faculty_name}</FormText>
//               )}
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Faculty Code</Label>
//               <Input
//                 name='faculty_code'
//                 value={facultyData.faculty_code}
//                 onChange={onChangeHandle}
//               />
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Mobile No</Label>
//               <Input
//                 name='mobile'
//                 value={facultyData.mobile}
//                 onChange={onChangeHandle}
//                 required
//               />
//               {errorMessage.mobile && (
//                 <FormText color='danger'>{errorMessage.mobile}</FormText>
//               )}
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Email</Label>
//               <Input
//                 name='email'
//                 value={facultyData.email}
//                 onChange={onChangeHandle}
//                 required
//               />
//               {errorMessage.email && (
//                 <FormText color='danger'>{errorMessage.email}</FormText>
//               )}
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Qualification</Label>
//               <Input
//                 type='select'
//                 className='custom-select'
//                 name='qualification'
//                 value={facultyData.qualification}
//                 onChange={onChangeHandle}
//               >
//                 <option value=''>Select Qualification</option>
//                 <option value='Graduate'>Graduate</option>
//                 <option value='Post Graduate'>Post Graduate</option>
//                 <option value='PhD'>PhD</option>
//                 <option value='Diploma'>Diploma</option>
//                 <option value='Other'>Other</option>
//               </Input>
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Experience</Label>
//               <Input
//                 type='select'
//                 className='custom-select'
//                 name='experience_years'
//                 value={facultyData.experience_years}
//                 onChange={onChangeHandle}
//               >
//                 <option value=''>Select Experience</option>
//                 <option value='Fresher'>Fresher</option>
//                 <option value='1+'>1+ Year</option>
//                 <option value='5+'>5+ Years</option>
//                 <option value='10+'>10+ Years</option>
//                 <option value='15+'>15+ Years</option>
//                 <option value='20+'>20+ Years</option>
//               </Input>
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Arrival Time</Label>
//               <Input
//                 type='time'
//                 name='arrival_time'
//                 value={facultyData.arrival_time}
//                 onChange={onChangeHandle}
//               />
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Departure Time</Label>
//               <Input
//                 type='time'
//                 name='departure_time'
//                 value={facultyData.departure_time}
//                 onChange={onChangeHandle}
//               />
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Main Subject Taught</Label>
//               <Input
//                 type='select'
//                 className='custom-select'
//                 name='main_subject_taught'
//                 value={facultyData.main_subject_taught}
//                 onChange={onChangeHandle}
//               >
//                 <option value=''>Select Subject</option>
//                 {subjectOptions.map((sub, key) => (
//                   <option key={key} value={sub.id}>
//                     {sub.subject_name}
//                   </option>
//                 ))}
//               </Input>
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Status</Label>
//               <Input
//                 type='select'
//                 className='custom-select'
//                 name='is_working'
//                 value={facultyData.is_working}
//                 onChange={onChangeHandle}
//               >
//                 <option value='true'>Currently Working</option>
//                 <option value='false'>Not Working</option>
//               </Input>
//             </FormGroup>
//             <FormGroup className='col-sm-6'>
//               <Label>Salary Amount</Label>
//               <Input
//                 type='number'
//                 name='salary_amount'
//                 value={facultyData.salary_amount}
//                 onChange={onChangeHandle}
//                 min='0'
//                 step='0.01'
//                 placeholder='Enter salary amount'
//               />
//             </FormGroup>
//             <FormGroup className='col-sm-6'>
//               <Label>Address</Label>
//               <Input
//                 name='address'
//                 value={facultyData.address}
//                 onChange={onChangeHandle}
//               />
//             </FormGroup>
//           </Row>

//           <div className='text-right'>
//             {Number(facultyData.faculty_id || facultyData.id) > 0 && (
//               <Button
//                 className='mt-2 mr-2 float-end'
//                 color='primary'
//                 onClick={handleSubmit}
//                 disabled={loading || isSubmitting}
//               >
//                 <i className='bi bi-key' />{' '}
//                 {loading ? 'Creating...' : 'Create Faculty Credentials'}
//               </Button>
//             )}

//             <Button
//               className='mt-2 float-end ms-2'
//               color='success'
//               onClick={AddFaculty}
//               disabled={loading || isSubmitting}
//             >
//               <i className='bi bi-check-circle' /> Save Faculty Details
//             </Button>
//           </div>
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default AddFacultyMaster;
//heena
import React, { useState, useEffect } from 'react';
import {
  Card,
  Row,
  CardTitle,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
  FormText,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';

const initialFacultyData = {
  id: 0,
  faculty_id: 0,
  vendor_id: 0,
  branch_id: 0,

  faculty_name: '',
  mobile: '',
  email: '',
  address: '',
  qualification: '',
  experience_years: '',
  arrival_time: '',
  departure_time: '',
  faculty_code: '',

  main_subject_taught: 0,

  // old UI status field
  is_working: 'true',

  // backend status field
  status: true,

  branch_name: '',

  // salary definition
  salary_definition_id: '',
  salary_amount: '',
  designation: '',
  leave_allowed: '',
};

const pick = (...vals) =>
  vals.find((v) => v !== undefined && v !== null && v !== '');

const normalizeBoolStr = (v) => {
  if (v === true || v === 'true' || v === 1 || v === '1') return 'true';
  if (v === false || v === 'false' || v === 0 || v === '0') return 'false';
  return 'true';
};

const AddFacultyMaster = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { user } = useSelector((state) => state.authState || {});
  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);

  const [branchMaster, setBranchMaster] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [salaryDefinitionList, setSalaryDefinitionList] = useState([]);

  const [facultyData, setFacultyData] = useState(initialFacultyData);
  const [errorMessage, setErrorMessage] = useState({});

  // =========================
  // EDIT LOAD
  // =========================
  useEffect(() => {
    if (location.state) {
      const s = location.state;

      setFacultyData({
        ...initialFacultyData,

        id: Number(pick(s.id, s.faculty_id, 0)),
        faculty_id: Number(pick(s.faculty_id, s.id, 0)),
        vendor_id: Number(pick(s.vendor_id, s.vendorId, 0)),
        branch_id: Number(pick(s.branch_id, s.branchId, 0)),

        faculty_name: pick(s.faculty_name, ''),
        mobile: pick(s.mobile, ''),
        email: pick(s.email, ''),
        address: pick(s.address, ''),
        qualification: pick(s.qualification, ''),
        experience_years: pick(s.experience_years, s.experienceYears, ''),
        arrival_time: pick(s.arrival_time, s.arrivalTime, ''),
        departure_time: pick(s.departure_time, s.departureTime, ''),
        faculty_code: pick(s.faculty_code, s.facultyCode, ''),

        main_subject_taught: Number(
          pick(
            s.main_subject_taught,
            s.main_subject_id,
            s.mainSubjectTaught,
            0,
          ),
        ),

        is_working: normalizeBoolStr(pick(s.is_working, s.status, 'true')),
        status: normalizeBoolStr(pick(s.is_working, s.status, 'true')) === 'true',

        branch_name: pick(s.branch_name, s.branchName, ''),

        salary_definition_id: pick(s.salary_definition_id, ''),
        salary_amount: pick(s.salary_amount, s.salaryAmount, ''),
        designation: pick(s.designation, ''),
        leave_allowed: pick(s.leave_allowed, ''),
      });
    } else {
      setFacultyData(initialFacultyData);
    }
  }, [location.state]);

  const onHandleBack = () => navigate('/faculty-list');

  const onChangeHandle = (e) => {
    const { name, value } = e.target;

    setFacultyData((prev) => ({
      ...prev,
      [name]:
        name === 'salary_amount'
          ? value === ''
            ? ''
            : Number(value)
          : value,

      // old UI is_working convert to backend status
      ...(name === 'is_working'
        ? {
            status: value === 'true',
          }
        : {}),
    }));

    setErrorMessage((prev) => ({ ...prev, [name]: '' }));
  };

  // =========================
  // LOAD SUBJECT OPTIONS
  // =========================
  const loadSubjectOptions = async (vendorId, branchId) => {
    try {
      // if (!vendorId && !branchId) {
      //   setSubjectOptions([]);
      //   return;
      // }

      const params = new URLSearchParams();

      if (vendorId) params.append('vendorId', vendorId);
      if (branchId) params.append('branchId', branchId);

      params.append('search', '');

      const url = `api/SubjectMaster/GetSubjectMaster?${params.toString()}`;
      const res = await apiService.get(url);
      const container = res?.data ?? res;

      const list =
        (Array.isArray(container.data) && container.data) ||
        (Array.isArray(container.Data) && container.Data) ||
        (Array.isArray(container.list) && container.list) ||
        (Array.isArray(container.result) && container.result) ||
        (Array.isArray(container) && container) ||
        [];

      setSubjectOptions(list);
    } catch (err) {
      console.error(err);
      toast.error('Error loading subject list');
      setSubjectOptions([]);
    }
  };

  // =========================
  // LOAD SALARY DEFINITION
  // =========================
  const loadSalaryDefinitionOptions = async (vendorId, branchId) => {
    try {
      if (!vendorId || !branchId) {
        setSalaryDefinitionList([]);
        return;
      }

      const res = await apiService.get(
        `api/SalaryDefinition/GetAllSalaryDefinition?vendorId=${vendorId}&branchId=${branchId}`,
      );

      console.log('GET SALARY DEFINITION RESPONSE:', res);

      if (res?.status === true) {
        setSalaryDefinitionList(res.data || res.Data || []);
      } else {
        setSalaryDefinitionList([]);
        toast.error(
          res?.message || res?.Message || 'Salary definition not found',
        );
      }
    } catch (err) {
      console.error(err);
      setSalaryDefinitionList([]);
      toast.error('Error loading salary definition');
    }
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: facultyData.vendor_id,
      branchId: facultyData.branch_id,
    });

    if (canLoad) {
      loadSubjectOptions(facultyData.vendor_id, facultyData.branch_id);
      loadSalaryDefinitionOptions(facultyData.vendor_id, facultyData.branch_id);
    } else {
      setSubjectOptions([]);
      setSalaryDefinitionList([]);
    }
  }, [
    facultyData.vendor_id,
    facultyData.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
  ]);

  const handleSalaryDefinitionChange = (e) => {
    const selectedId = e.target.value;

    if (!selectedId) {
      setFacultyData((prev) => ({
        ...prev,
        salary_definition_id: '',
        salary_amount: '',
        designation: '',
        leave_allowed: '',
      }));
      return;
    }

    const selected = salaryDefinitionList.find(
      (x) => String(x.id) === String(selectedId),
    );

    setFacultyData((prev) => ({
      ...prev,
      salary_definition_id: selected?.id || '',
      salary_amount: selected?.salary || '',
      designation: selected?.designation || '',
      leave_allowed: selected?.leave_allowed || '',
    }));
  };

  // =========================
  // BRANCH NAME FOR CREDENTIALS
  // =========================
  const fetchBranches = async (vendorId) => {
    try {
      if (!vendorId || Number(vendorId) <= 0) {
        setBranchMaster([]);
        return [];
      }

      const url = `/api/BranchMaster/all?pageNo=1&limit=100000&searchKey=&venderMasterId=${vendorId}`;
      const res = await apiService.get(url);

      if (res?.status === true) {
        const arr = Array.isArray(res?.branchMasterData)
          ? res.branchMasterData
          : [];

        const normalized = arr.map((x) => ({
          ...x,
          __id: Number(x?.id || 0),
          __name: String(x?.branch_name || '').trim(),
        }));

        setBranchMaster(normalized);
        return normalized;
      }

      setBranchMaster([]);
      return [];
    } catch (e) {
      console.log(e);
      setBranchMaster([]);
      return [];
    }
  };

  useEffect(() => {
    if (facultyData.vendor_id) {
      fetchBranches(facultyData.vendor_id);
    }
  }, [facultyData.vendor_id]);

  const buildBranchIdAndNames = async (vendorId, branchId) => {
    const vid = Number(vendorId || 0);
    const bid = Number(branchId || 0);

    if (vid <= 0 || bid <= 0) return '';

    let list = branchMaster;

    if (!list || list.length === 0) {
      list = await fetchBranches(vid);
    }

    const row = (list || []).find((b) => Number(b.__id) === bid);
    const name = row?.__name ? String(row.__name).trim() : '';

    return name ? `${bid}-${name}` : String(bid);
  };

  // =========================
  // VALIDATION
  // =========================
  const validateInputs = () => {
    const errors = {};

    if (
      isSuperAdmin &&
      (!facultyData.vendor_id || Number(facultyData.vendor_id) <= 0)
    ) {
      errors.vendor_id = 'Vendor is Required';
      toast.error('Please select a Vendor');
    }

    if (
      (isSuperAdmin || isAdmin || hasMultiBranch) &&
      (!facultyData.branch_id || Number(facultyData.branch_id) <= 0)
    ) {
      errors.branch_id = 'Branch is Required';
      toast.error('Please select a Branch');
    }

    if (!facultyData.faculty_name?.trim()) {
      errors.faculty_name = 'Faculty Name Required';
    }

    if (!facultyData.salary_definition_id) {
      errors.salary_definition_id = 'Designation Required';
      toast.error('Please select Designation');
    }

    if (!facultyData.mobile?.trim()) {
      errors.mobile = 'Mobile number is required';
    } else if (!/^[6-9]\d{9}$/.test(facultyData.mobile.trim())) {
      errors.mobile = 'Enter a valid 10-digit mobile number';
    }

    if (!facultyData.email?.trim()) {
      errors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(facultyData.email.trim())) {
      errors.email = 'Enter a valid email address';
    }

    setErrorMessage(errors);
    return Object.keys(errors).length === 0;
  };

  // =========================
  // SAVE FACULTY
  // =========================
  const AddFaculty = async () => {
    const ok = validateInputs();
    if (!ok) return;

    try {
      const payload = {
        ...facultyData,

        vendor_id: facultyData.vendor_id
          ? Number(facultyData.vendor_id)
          : null,

        branch_id: facultyData.branch_id
          ? Number(facultyData.branch_id)
          : null,

        main_subject_taught: facultyData.main_subject_taught
          ? Number(facultyData.main_subject_taught)
          : null,

        salary_definition_id: facultyData.salary_definition_id
          ? Number(facultyData.salary_definition_id)
          : null,

        salary_amount:
          facultyData.salary_amount === '' || facultyData.salary_amount === null
            ? null
            : Number(facultyData.salary_amount),

        status: facultyData.is_working === 'true',
      };

      let response;

      const id = Number(facultyData.faculty_id || facultyData.id || 0);

      if (id > 0) {
        response = await apiService.put(
          `api/FacultyMaster/UpdateFaculty?id=${id}`,
          payload,
        );
      } else {
        response = await apiService.post(`api/FacultyMaster/AddFaculty`, payload);
      }

      console.log('SAVE FACULTY RESPONSE:', response);

      if (response?.status === true) {
        toast.success(response.message || response.Message || 'Saved successfully');
        navigate('/faculty-list');
      } else {
        toast.error(response?.message || response?.Message || 'Failed');
      }
    } catch (e) {
      console.log(e);
      toast.error('SomeThing went wrong!!');
    }
  };

  // =========================
  // CREATE CREDENTIALS
  // =========================
  const handleSubmit = async () => {
    if (isSubmitting) return;

    const ok = validateInputs();
    if (!ok) return;

    const selectedFacultyId = Number(
      facultyData.faculty_id || facultyData.id || 0,
    );

    if (!selectedFacultyId || selectedFacultyId <= 0) {
      toast.error('Please save faculty details first');
      return;
    }

    setIsSubmitting(true);
    setLoading(true);

    try {
      const vendorId = Number(facultyData.vendor_id || 0);
      const branchId = Number(facultyData.branch_id || 0);
      const branchIdAndNames = await buildBranchIdAndNames(vendorId, branchId);

      const params = {
        vender_master_id: vendorId,
        branch_id: branchId,
        branch_id_and_names: branchIdAndNames,

        sponsored_user_mobile: facultyData.mobile,
        user_name: facultyData.faculty_name,
        user_mobile: facultyData.mobile,
        user_pass: facultyData.mobile,
        confirm_user_pass: facultyData.mobile,
        user_email: facultyData.email || '',

        user_profile_id: 9,
        working_bussinesss_mode: 'SCHOOL',
        user_status: 'ACTIVE',

        tbl_link_id: selectedFacultyId,
        tbl_linked_with: 'FACULTY_MASTER',
      };

      const response = await apiService.post(
        `api/admin/User_Detail/branch/CreateUser`,
        params,
      );

      if (response?.status === true) {
        toast.success(response.message || 'User created');
      } else {
        toast.error(response?.message || 'Failed');
      }
    } catch (err) {
      console.log(err);
      toast.error('SomeThing went wrong!!');
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <VendorBranchSelector
        user={user}
        selectionData={facultyData}
        setSelectionData={setFacultyData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box height-100-p pd-20 mb-20'>
        <CardTitle
          tag='h6'
          className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
        >
          <div className='d-flex align-items-center'>
            <i className='bi bi-person-video3 mr-2'></i>
            Faculty Master Form
          </div>

          <div>
            <Button color='warning' onClick={onHandleBack} className='mr-2'>
              Back
            </Button>
          </div>
        </CardTitle>

        <CardBody>
          <Row>
            <FormGroup className='col-sm-6'>
              <Label>Faculty Name</Label>
              <Input
                name='faculty_name'
                value={facultyData.faculty_name}
                onChange={onChangeHandle}
                required
              />
              {errorMessage.faculty_name && (
                <FormText color='danger'>{errorMessage.faculty_name}</FormText>
              )}
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Faculty Code</Label>
              <Input
                name='faculty_code'
                value={facultyData.faculty_code}
                onChange={onChangeHandle}
                placeholder='Auto if blank'
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Designation</Label>
              <Input
                type='select'
                className='custom-select'
                name='salary_definition_id'
                value={facultyData.salary_definition_id}
                onChange={handleSalaryDefinitionChange}
              >
                <option value=''>Select Designation</option>
                {salaryDefinitionList.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.designation}
                  </option>
                ))}
              </Input>
              {errorMessage.salary_definition_id && (
                <FormText color='danger'>
                  {errorMessage.salary_definition_id}
                </FormText>
              )}
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Salary Amount</Label>
              <Input
                type='number'
                name='salary_amount'
                value={facultyData.salary_amount}
                onChange={onChangeHandle}
                min='0'
                step='0.01'
                placeholder='Enter salary amount'
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Leave Allowed</Label>
              <Input
                type='number'
                name='leave_allowed'
                value={facultyData.leave_allowed}
                readOnly
                placeholder='Leave Allowed'
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Mobile No</Label>
              <Input
                name='mobile'
                value={facultyData.mobile}
                onChange={onChangeHandle}
                required
              />
              {errorMessage.mobile && (
                <FormText color='danger'>{errorMessage.mobile}</FormText>
              )}
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Email</Label>
              <Input
                name='email'
                value={facultyData.email}
                onChange={onChangeHandle}
                required
              />
              {errorMessage.email && (
                <FormText color='danger'>{errorMessage.email}</FormText>
              )}
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Qualification</Label>
              <Input
                type='select'
                className='custom-select'
                name='qualification'
                value={facultyData.qualification}
                onChange={onChangeHandle}
              >
                <option value=''>Select Qualification</option>
                <option value='Graduate'>Graduate</option>
                <option value='Post Graduate'>Post Graduate</option>
                <option value='PhD'>PhD</option>
                <option value='Diploma'>Diploma</option>
                <option value='Other'>Other</option>
              </Input>
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Experience</Label>
              <Input
                type='select'
                className='custom-select'
                name='experience_years'
                value={facultyData.experience_years}
                onChange={onChangeHandle}
              >
                <option value=''>Select Experience</option>
                <option value='Fresher'>Fresher</option>
                <option value='1+'>1+ Year</option>
                <option value='5+'>5+ Years</option>
                <option value='10+'>10+ Years</option>
                <option value='15+'>15+ Years</option>
                <option value='20+'>20+ Years</option>
              </Input>
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Arrival Time</Label>
              <Input
                type='time'
                name='arrival_time'
                value={facultyData.arrival_time}
                onChange={onChangeHandle}
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Departure Time</Label>
              <Input
                type='time'
                name='departure_time'
                value={facultyData.departure_time}
                onChange={onChangeHandle}
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Main Subject Taught</Label>
              <Input
                type='select'
                className='custom-select'
                name='main_subject_taught'
                value={facultyData.main_subject_taught}
                onChange={onChangeHandle}
              >
                <option value=''>Select Subject</option>
                {subjectOptions.map((sub, key) => (
                  <option key={key} value={sub.id}>
                    {sub.subject_name}
                  </option>
                ))}
              </Input>
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Status</Label>
              <Input
                type='select'
                className='custom-select'
                name='is_working'
                value={facultyData.is_working}
                onChange={onChangeHandle}
              >
                <option value='true'>Currently Working</option>
                <option value='false'>Not Working</option>
              </Input>
            </FormGroup>

            <FormGroup className='col-sm-12'>
              <Label>Address</Label>
              <Input
                name='address'
                value={facultyData.address}
                onChange={onChangeHandle}
              />
            </FormGroup>
          </Row>

          <div className='text-right'>
            {Number(facultyData.faculty_id || facultyData.id) > 0 && (
              <Button
                className='mt-2 mr-2 float-end'
                color='primary'
                onClick={handleSubmit}
                disabled={loading || isSubmitting}
              >
                <i className='bi bi-key' />{' '}
                {loading ? 'Creating...' : 'Create Faculty Credentials'}
              </Button>
            )}

            <Button
              className='mt-2 float-end ms-2'
              color='success'
              onClick={AddFaculty}
              disabled={loading || isSubmitting}
            >
              <i className='bi bi-check-circle' /> Save Faculty Details
            </Button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default AddFacultyMaster; 